<template>
    <div>
        <v-app-bar v-if="isXs" app elevation="0" class="nav-clean px-4" :class="{ expand: flat }">
            <v-app-bar-nav-icon v-if="isXs" color="#111111" @click.stop="drawer = !drawer" />
            <v-toolbar-title>
                <v-img src="@/assets/images/logo-mazzitech.png" contain max-width="160" />
            </v-toolbar-title>
            <v-spacer />
        </v-app-bar>

        <v-app-bar v-else fixed app elevation="0" class="nav-clean nav-desktop" :class="{ expand: flat }">
            <div class="nav-shell">
                <v-toolbar-title class="nav-brand">
                    <v-img
                        class="cursor-pointer"
                        src="@/assets/images/logo-mazzitech.png"
                        contain
                        max-width="180"
                        @click="scrollToAnchor('home')"
                    />
                </v-toolbar-title>
                <nav class="nav-links" aria-label="Navegação principal">
                    <a v-for="(item, index) in menuItems" :key="index" class="nav-link" @click="scrollToAnchor(item.ref)">
                        {{ item.text }}
                    </a>
                </nav>
                <div class="nav-action">
                    <button class="btn-nav" type="button" @click="scrollToAnchor('contact')">
                        Contato
                    </button>
                </div>
            </div>
        </v-app-bar>

        <v-navigation-drawer v-model="drawer" fixed temporary class="drawer-clean">
            <v-list nav dense class="mt-4">
                <v-list-item-group>
                    <v-list-item v-for="(item, index) in menuItems" :key="index" link @click="scrollToAnchor(item.ref)">
                        <v-list-item-content>
                            <v-list-item-title class="drawer-link">{{ item.text }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
export default {
    data: () => ({
        drawer: null,
        isXs: false,
        menuItems: [
            { icon: "mdi-home-outline", text: "Início", ref: "home" },
            { icon: "mdi-account-group-outline", text: "Clientes", ref: "partners" },
            { icon: "mdi-information-outline", text: "Propósito", ref: "aboutus" },
            { icon: "mdi-briefcase-outline", text: "Serviços", ref: "services" },
        ],
    }),
    props: {
        color: String,
        flat: Boolean,
    },
    methods: {
        onResize() {
            this.isXs = window.innerWidth < 850;
        },
        scrollToAnchor(anchor) {
            const section = document.getElementById(anchor);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        },
    },
    watch: {
        isXs(value) {
            if (!value && this.drawer) {
                this.drawer = false;
            }
        },
    },
    mounted() {
        this.onResize();
        window.addEventListener("resize", this.onResize, { passive: true });
    },
};
</script>

<style>
.v-toolbar {
    transition: 0.6s;
}

.expand {
    height: 80px !important;
    padding-top: 10px;
}

.nav-clean {
    background: #f4f4f2 !important;
    background-color: #f4f4f2 !important;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border-bottom: 1px solid rgba(17, 17, 17, 0.08) !important;
    z-index: 100 !important;
}

.nav-desktop {
    padding: 0 !important;
}

.nav-desktop .v-toolbar__content {
    width: 100%;
    padding: 0 !important;
}

.nav-shell {
    display: grid;
    grid-template-columns: minmax(220px, 1fr) auto minmax(220px, 1fr);
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 clamp(32px, 3.8vw, 76px);
}

.nav-brand,
.nav-action {
    display: flex;
    align-items: center;
    min-width: 0;
}

.nav-action {
    justify-content: flex-end;
}

.drawer-clean {
    background: #fafaf8 !important;
}

.drawer-link {
    color: #111111 !important;
    font-size: 14px !important;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.nav-links {
    display: flex;
    justify-content: center;
    gap: clamp(12px, 1.6vw, 28px);
    min-width: 0;
}

.nav-link {
    position: relative;
    color: #282824 !important;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 8px 0;
    cursor: pointer;
    transition: color 0.25s ease;
    text-decoration: none !important;
}

.nav-link:hover {
    color: #0f4efb !important;
}

.nav-link::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: #0f4efb;
    opacity: 0;
    transition: opacity 0.25s ease;
}

.nav-link:hover::after {
    opacity: 1;
}

.btn-nav {
    min-width: 126px;
    padding: 13px 24px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #ffffff !important;
    background: #0f4efb;
    border: 1px solid #0f4efb;
    border-radius: 2px;
    cursor: pointer;
    transition: background 0.25s ease, border-color 0.25s ease;
    outline: none;
    font-family: "Plus Jakarta Sans", sans-serif !important;
}

.btn-nav:hover {
    background: #0b3fd3;
    border-color: #0b3fd3;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
